import { render, staticRenderFns } from "./DialogMensagem.vue?vue&type=template&id=bab81abe"
import script from "./DialogMensagem.vue?vue&type=script&lang=js"
export * from "./DialogMensagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports